import React, { ChangeEvent, useCallback, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import TextareaAutosize from 'react-textarea-autosize';
import { ResolutionLabel } from '../../../../../components/EmployeeFeedback/ResolutionLabel';

type Props = {
  resolutionId: string;
  disabled?: boolean;
  value: string | null;
  onUpdateResolution: (params: { resolutionId: string; value: string }) => void;
};

export const ResolutionInput: React.FC<React.PropsWithChildren<Props>> = ({
  resolutionId,
  value,
  disabled,
  onUpdateResolution,
}) => {
  const [inputValue, setInputValue] = useState<string>(value ?? '');

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => {
      const {
        target: { value },
      } = event;

      setInputValue(value);
      onUpdateResolution({ resolutionId, value });
    },
    [onUpdateResolution, resolutionId, setInputValue],
  );

  return (
    <Row>
      <Col>
        <ResolutionLabel isSaving={false} />
        <TextareaAutosize
          className="form-control"
          onChange={handleChange}
          value={inputValue}
          disabled={disabled}
        />
      </Col>
    </Row>
  );
};
